import watchListAllRelatorioEstoqueProducaoPorPeriodo from './saga/estoqueProducaoPorPeriodo';

export const relatorioEstoqueProducaoPorPeriodoSaga = [
    watchListAllRelatorioEstoqueProducaoPorPeriodo(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
